export abstract class zendeskWebwidgetConfig {
  abstract beforePageLoad(zE): any;
  lazyLoad: boolean;
  timeOut: number;
  injectionTag: 'head' | 'body' | 'script' | 'style' | string;
  abstract accountUrl: string;
  abstract callback(zE): any;
}